import React, { useState, useRef, useEffect } from "react";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import classes from "./customSelect.module.css";

export const CustomSelect = ({
  options = [],
  value = "",
  onChange,
  placeholder = "Select an option",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const selectedOption = options.find(
    (opt) => (opt.id || opt.value) === value
  );

  const handleSelect = (option) => {
    onChange?.(option.id || option.value);
    setIsOpen(false);
  };

  // Close on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className={classes.select} ref={dropdownRef}>
      {/* Trigger */}
      <div
        className={`${classes.select__trigger} ${
          isOpen ? classes.open : ""
        }`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <span>
          {selectedOption ? selectedOption.label : placeholder}
        </span>

        <ChevronDownIcon
          className={`${classes.icon} ${isOpen ? classes.rotate : ""}`}
        />
      </div>

      {/* Dropdown */}
      <div
        className={`${classes.dropdown} ${
          isOpen ? classes.show : ""
        }`}
      >
        {options.map((option) => {
          const optionValue = option.id || option.value;
          const isSelected = optionValue === value;

          return (
            <div
              key={optionValue}
              className={`${classes.option} ${
                isSelected ? classes.selected : ""
              }`}
              onClick={() => handleSelect(option)}
            >
              {option.label}
            </div>
          );
        })}
      </div>
    </div>
  );
};